import { Button, Row, Spinner } from "reactstrap";
import FilterAdmin from "../../components/FilterAdmin/FilterAdmin";
import CustomDatatable from "../../components/CustomDatatable/CustomDatatable";
import { connect } from "react-redux";
import {
  changePageSizeStyle,
  cleanMessageStyle,
  getListaStyle,
  getStyleHistoryList,
} from "../../store/style/actions";
import { useEffect, useState } from "react";
import { useIsFirstRender } from "../../customHooks/useIsFirstRender";
import renderHeader from "../../components/RenderCellsDatatable/renderHeader";
import renderBoolean from "../../components/RenderCellsDatatable/renderBoolean";
import renderFormatedDate from "../../components/RenderCellsDatatable/renderFormatterDate";
import HistoryModal from "../../components/HistoryModal/HistoryModal";
import moment from "moment";
import { styleTypes } from "../../enums/styleTypes";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useContextActions } from "../../customHooks/useContextActions";
import { PAGE_SIZE_OPTIONS } from "../../constants/pagination";

const GenericStyleList = ({
  getListaStyleRequest,
  getStyleHistoryList,
  changePageSizeStyle,
  pageSizeStyle,
  loadingStyle,
  loadingStyleHistory,
  listaStyle,
  listaStyleHistory,
  type,
  messageStyle,
  cleanMessageStyle,
  errorLoadingStyleHistory,
  navigateToCreate
}) => {
  const isFistRender = useIsFirstRender();
  const navigate = useNavigate();
  const alertModal = withReactContent(Swal);
  const [objFilter, setObjFilter] = useState({
    createDateStart: null,
    updateDateStart: null,
    createDateEnd: null,
    updateDateEnd: null,
    createUser: null,
    updateUser: null,
    status: true,
  });
  const [paginationModel, setPaginationModel] = useState({
    pageSize: pageSizeStyle,
    page: 0,
  });

  const [currentPageHistory, setCurrentPageHistory] = useState(1);
  const [idCurrentStyleHistory, setIdCurrentStyleHistory] = useState(null);
  const pageSizeHistory = 10;
  const totalPagesHistory = Math.ceil(
    (listaStyleHistory?.totalRecords || 0) / pageSizeHistory
  );
  const handlePageChangeHistory = (page) => {
    if (!idCurrentStyleHistory) return;
    if (page < 1 || page > totalPagesHistory) return;
    setCurrentPageHistory(page);
    
    getStyleHistoryList({ 
      styleId: idCurrentStyleHistory, 
      page 
    });
  };
  const handlePageChange = (model) => {
    const { page, pageSize } = model;
    setPaginationModel({
      pageSize: pageSize,
      page: page,
    });
    changePageSizeStyle(pageSize);

    getListaStyleRequest({
      pageNumber: page + 1,
      pageSize: pageSize,
      createDateStart: objFilter.createDateStart,
      updateDateStart: objFilter.updateDateStart,
      createDateEnd: objFilter.createDateEnd,
      updateDateEnd: objFilter.updateDateEnd,
      createUser: objFilter.createUser,
      updateUser: objFilter.updateUser,
      status: objFilter.status,
      title: objFilter.search,
      type: type,
    });
  };
  const handleSortChange = (model) => {
    console.log(model);
    setTimeout(() => {
      //
    }, 300);
  };
  const handleRowClick = (params, event) => {
    if (type === styleTypes.TABLE) {
      navigate(`/table-style?id=${params.id}`);
    } else if (type === styleTypes.LIST) {
      navigate(`/list-style?id=${params.id}`);
    } else if (type === styleTypes.TEXT) {
      navigate(`/text-style?id=${params.id}`);
    }
  };
  const fetchStyleHistory = (styleId) => {
    getStyleHistoryList({ styleId, page: 1 });
  };
  const handleDetailStyleHistory = (item) => {
    if (type === styleTypes.TABLE) {
      window.open(`/table-style?idHistory=${item.idHistory}`, "_blank");
    } else if (type === styleTypes.LIST) {
      window.open(`/list-style?idHistory=${item.idHistory}`, "_blank");
    } else if (type === styleTypes.TEXT) {
      window.open(`/text-style?idHistory=${item.idHistory}`, "_blank");
    }
  };

  const columns = [
    {
      field: "title",
      headerName: "Title",
      flex: 1,
      sortable: false,
      renderHeader: renderHeader,
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
      sortable: false,
      renderHeader: renderHeader,
    },
    {
      field: "active",
      headerName: "Active Status",
      flex: 1,
      type: "boolean",
      sortable: false,
      renderHeader: renderHeader,
      renderCell: renderBoolean,
    },
    {
      field: "createDate",
      headerName: "Creation Date",
      flex: 1,
      renderCell: renderFormatedDate,
      sortable: false,
      renderHeader: renderHeader,
    },
    {
      field: "updateDate",
      headerName: "Update Date",
      flex: 1,
      renderCell: renderFormatedDate,
      sortable: false,
      renderHeader: renderHeader,
    },
    {
      field: "id",
      headerName: "History",
      flex: 1,
      renderCell: (params) => (
        <HistoryModal
          trigger={
            <Button color="" style={{ width: 50, height: 50 }}>
              <i className="fas fa-history"></i>
            </Button>
          }
          fetchHistory={() => {
            fetchStyleHistory(params.value)
            setCurrentPageHistory(1);
            setIdCurrentStyleHistory(params.value);
          }}
          loading={loadingStyleHistory}
          data={listaStyleHistory?.records}
          onDetail={handleDetailStyleHistory}
          errorLoadingHistory={errorLoadingStyleHistory}

          handlePageChange={handlePageChangeHistory}
          totalPages={totalPagesHistory}
          currentPage={currentPageHistory}
          
          columns={[
            {
              key: "updateDate",
              render: (item) => 
                moment(item.updateDate === null ? item.createDate : item.updateDate).format("DD MMM/YY hh:mm A"),
            },
            { key: "title" },
            { key: "updateUser",
              render : (item) => 
                item.updateUser === null ? item.createUser : item.updateUser
             },
          ]}
        />
      ),
      sortable: false,
      renderHeader: renderHeader,
    },
  ];

  const actions = useContextActions({
    context: "style",
    screen: "list",
  })
  const handlers = 
    styleTypes.TABLE === type
      ? "table-style"
      : styleTypes.LIST === type
      ? "list-style"
      : "text-style";

  useEffect(() => {
    setPaginationModel((prev) => ({
      ...prev,
      page: 0,
    }));

    getListaStyleRequest({
      pageNumber: 1,
      pageSize: paginationModel.pageSize,
      createDateStart: objFilter.createDateStart,
      updateDateStart: objFilter.updateDateStart,
      createDateEnd: objFilter.createDateEnd,
      updateDateEnd: objFilter.updateDateEnd,
      createUser: objFilter.createUser,
      updateUser: objFilter.updateUser,
      status: objFilter.status,
      title: objFilter.search,
      type: type,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [objFilter]);
  useEffect(() => {
    if (messageStyle) {
      alertModal
        .fire({
          title: `${
            messageStyle !== null
              ? messageStyle
              : "Something wrong, try again later."
          }`,
          icon: "error",
          showConfirmButton: false,
          timer: undefined,
          showCloseButton: true,
          timerProgressBar: false,
        })
        .then(() => {
          cleanMessageStyle();
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageStyle]);
  useEffect(() => {
    navigateToCreate({
      actions: actions,
      handlers: handlers,
    })
    return () => {
      cleanMessageStyle();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <FilterAdmin
        setObjFilter={setObjFilter}
        placeholderSearch={"Search by title"}
        isFistRender={isFistRender}
      />
      <Row className="my-2">
        {loadingStyle ? (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ height: "400px", width: "100%" }}
          >
            <Spinner
              color="primary"
              style={{ height: "5rem", width: "5rem" }}
            />
          </div>
        ) : (
          <>
            <CustomDatatable
              columns={columns}
              rows={listaStyle.records}
              rowCount={listaStyle.totalRecords}
              pagination
              paginationMode="server"
              paginationModel={paginationModel}
              onPaginationModelChange={handlePageChange}
              onSortModelChange={handleSortChange}
              onRowClick={handleRowClick}
              pageSizeOptions={PAGE_SIZE_OPTIONS}
              checkboxSelection={false}
              disableColumnFilter
              disableColumnMenu
            />
          </>
        )}
      </Row>
    </>
  );
};

const mapStateToProps = ({
  StyleReducer: {
    loadingStyle,
    loadingStyleHistory,
    listaStyle,
    listaStyleHistory,
    pageSizeStyle,
    messageStyle,
    errorLoadingStyleHistory,
  },
}) => ({
  loadingStyle,
  loadingStyleHistory,
  listaStyle,
  listaStyleHistory,
  pageSizeStyle,
  messageStyle,
  errorLoadingStyleHistory,
});

const mapDispatchToProps = {
  getListaStyleRequest: getListaStyle.request,
  getStyleHistoryList: getStyleHistoryList.request,
  changePageSizeStyle: changePageSizeStyle,
  cleanMessageStyle: cleanMessageStyle,
};

export default connect(mapStateToProps, mapDispatchToProps)(GenericStyleList);
